import { Alert, Empty, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GRAPHIC_PAGE_TYPE_LABELS, type GraphicPage } from '../graphicPageTypes'
import { fetchPublicGraphicPages, type PublicApiError } from './publicApi'

/** Public "图文编辑" list — published-only (spec §39/§43), same
 * `pub-grid`/`pub-card` visual language as every other public list page
 * (`PublicPublicationListPage.tsx`) for shell consistency. */
export default function GraphicPagesPublicList({ workspaceSlug, siteSlug }: { workspaceSlug: string; siteSlug: string }) {
  const [rows, setRows] = useState<GraphicPage[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`

  useEffect(() => {
    setRows(null)
    setError(null)
    fetchPublicGraphicPages(workspaceSlug, siteSlug)
      .then((r) => setRows(r.data.items))
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug])

  if (error) return <div className="pub-page"><Alert type="error" message={error} showIcon /></div>

  return (
    <div className="pub-page">
      <h1>图文</h1>
      {rows === null ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : rows.length === 0 ? (
        <Empty className="pub-empty" description="暂无图文页面" />
      ) : (
        <div className="pub-grid" style={{ marginTop: 24 }}>
          {rows.map((r) => (
            <Link key={r.slug} to={`${base}/graphic-pages/${r.slug}`} className="pub-card">
              <div className="pub-card-cover">{r.cover_url && <img src={r.cover_url} alt={r.title} />}</div>
              <div className="pub-card-body">
                <p className="pub-card-title">{r.title}</p>
                <p className="pub-card-meta">{GRAPHIC_PAGE_TYPE_LABELS[r.page_type]}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
